<p-table #dt [value]="Staff" dataKey="Id" [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-striped"
  [loading]="staffLoading" [globalFilterFields]="['Name', 'GalleryStaffPosition', 'PhoneNumber', 'Email']" selectionMode="single"
  [paginator]="Staff.length > 15? true: false" [rows]="15" [reorderableColumns]="true" [resizableColumns]="false">
  <!-- Table Caption Template -->
  <ng-template pTemplate="caption">
    <div class="table-header">
      <div class="row">
        <div class="col-md-6 text-right">
          <div
            class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
            <button type="button"
              class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
              <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
            </button>
            <input type="text"
              class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
              (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'galleryStaff.searchPlaceholder' | transloco" />
            </div>
          </div>
          <div class="col-md-6 text-left">
            <div class="d-flex justify-content-end align-items-center">
              <button type="button" pButton icon="fa fa-plus" [label]="'galleryStaff.addNew' | transloco"
              class="ms-2 p-button p-button-secondary p-button-sm p-button-outlined" (click)="showDailog()"></button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Table Header Template -->
    <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
      <tr>
        <th [pSortableColumn]="'Fullname'">
          {{ 'galleryStaff.fullName' | transloco }} <p-sortIcon [field]="'Fullname'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'Email'">
          {{ 'galleryStaff.email' | transloco }} <p-sortIcon [field]="'Email'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'Position'">{{ 'galleryStaff.position' | transloco }}</th>
        <th [pSortableColumn]="'Mobile'">{{ 'galleryStaff.mobile' | transloco }}</th>
        <th>{{ 'galleryStaff.actions' | transloco }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
      <tr>
        <td>
          {{ rowData.Name }}
        </td>
        <td>
          {{ rowData.Email }}
        </td>
        <td>{{ rowData.GalleryStaffPosition }}</td>
        <td>{{ rowData.PhoneNumber }}</td>
        <td>
          <div class="d-flex align-items-center">
            <button pButton (click)="editGalleryStaff(rowData.Id)" class="p-button p-button-sm me-1 p-button-outlined"
            icon="pi pi-pencil" size="small"></button>
            <button pButton (click)="showPermissionDailog(rowData.Id)"
              class="p-button-primary p-button-sm me-1 p-button-outlined" icon="pi pi-unlock" size="small">
            </button>
            <button pButton (click)="deleteGalleryStaff(rowData.Id)"
              class="p-button-danger p-button-sm me-1 p-button-outlined" icon="pi pi-trash" size="small">
            </button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty Message Template -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="5">
          <div class="text-center">{{ 'galleryStaff.noStaffFound' | transloco }}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- gallery staff dailog -->
  <p-dialog [header]="isEditMode ? ('galleryStaff.editStaff' | transloco) : ('galleryStaff.addStaff' | transloco)" [(visible)]="staffDailogVisible" [modal]="true"
    [style]="{ 'width': '420px','min-height': '420px' }" (onHide)="closeDialog()">
    <div class="p-fluid px-4">
      <form class="form-horizontal" #artistForm="ngForm">
        <!-- Full Name -->
        <div class="form-group mt-3">
          <label for="fullName"><span class="text-danger me-1">*</span> {{ 'galleryStaff.name' | transloco }}</label>
          <input type="text" id="fullName" pInputText [placeholder]="'galleryStaff.fullNamePlaceholder' | transloco" class="form-control form-control-sm"
            [(ngModel)]="staffFormsData.FirstName" name="fullName" required />
          </div>

          <!-- Position Dropdown -->
          <div class="form-group mt-2">
            <label for="position" class="form-label">{{ 'galleryStaff.position' | transloco }}</label>
            <p-dropdown id="position" [options]="staffRoleOptions" [(ngModel)]="selectedStaffRole"
              name="position" [placeholder]="'galleryStaff.selectPosition' | transloco" [showClear]="true"
              styleClass="w-100" (onChange)="onRoleChange()">
            </p-dropdown>
          </div>

          <!-- Custom Position (visible only when "Other" is selected) -->
          @if (selectedStaffRole === GalleryStaffRoleEnum.Other) {
            <div class="form-group mt-2">
              <label for="customPosition" class="form-label">{{ 'galleryStaff.customPosition' | transloco }}</label>
              <input id="customPosition" type="text" pInputText [placeholder]="'galleryStaff.enterCustomPosition' | transloco"
                class="form-control form-control-sm" [(ngModel)]="customPosition" name="customPosition" />
              </div>
            }

            <!-- Email -->
            <div class="form-group mt-2">
              <label for="email" class="form-label"><span class="text-danger me-1">*</span> {{ 'galleryStaff.email' | transloco }}</label>
              <input id="email" type="email" pInputText [placeholder]="'galleryStaff.email' | transloco" class="form-control form-control-sm"
                [(ngModel)]="staffFormsData.Email" name="email" required />
              </div>

              <!-- Phone Number -->
              <div class="form-group mt-2">
                <label for="phoneNumber" class="form-label">{{ 'galleryStaff.phoneNumber' | transloco }}</label>
                <input id="phoneNumber" type="tel" pInputText [placeholder]="'galleryStaff.phoneNumber' | transloco" class="form-control form-control-sm"
                  [(ngModel)]="staffFormsData.PhoneNumber" name="phoneNumber" />
                </div>

                <!-- Staff -->
                <div class="form-group mt-2">
                  <label class="form-label">{{ 'galleryStaff.notes' | transloco }}</label>
                  <textarea rows="3" [(ngModel)]="staffFormsData.GalleryStaffNotes" pInputTextarea [autoResize]="true"
                  name="Staff"></textarea>
                </div>
                <div class="d-flex align-items-center">
                  <!-- <button pButton type="button"  label="Cancel" class="mt-2 mx-3" (click)="onCancel()"></button> -->
                  <button pButton type="button" [label]="'galleryStaff.save' | transloco" class="mt-2 p-button-outlined"
                  [disabled]="!staffFormsData.FirstName || !staffFormsData.Email" (click)="saveGalleryStaff()"></button>
                </div>
              </form>
            </div>
          </p-dialog>

          <!-- permissions dailog -->
          <p-dialog [header]="'galleryStaff.addPermissions' | transloco" [(visible)]="isPermissionDailogVisible" [modal]="true"
            (onHide)="onClosePermissionDailog()" [style]="{'width': '420px'}">
            <div>{{ 'galleryStaff.permissionsDescription' | transloco }}</div>

            <div class="flex flex-column align-items-center justify-content-center mt-2">
              <p-tree [value]="permission" selectionMode="checkbox" class="w-full md:w-30rem" [filter]="true" [loading]="loadingPermissions"
                [filterPlaceholder]="'galleryStaff.searchPermissionPlaceholder' | transloco" (onNodeSelect)="onselectedPermissionIds($event)" [(selection)]="selectedPermission">
              </p-tree>
            </div>
            <div>
              <button pButton type="button" [label]="'galleryStaff.saveChanges' | transloco" class="mt-2 p-button-outlined w-100"
              (click)="savePermissions()"></button>
            </div>
          </p-dialog>